import { render, staticRenderFns } from "./independent-study-filter.vue?vue&type=template&id=54e1b7ba&scoped=true&"
import script from "./independent-study-filter.ts?vue&type=script&lang=ts&"
export * from "./independent-study-filter.ts?vue&type=script&lang=ts&"
import style0 from "./independent-study-filter.scss?vue&type=style&index=0&id=54e1b7ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1b7ba",
  null
  
)

export default component.exports